/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionPlusIcon24Solid = forwardRef('TextActionPlusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 4.5Z" }),
        React.createElement("path", { d: "M3.5 8a1.5 1.5 0 1 0 0 3h17a1.5 1.5 0 0 0 0-3h-17Z" }),
        React.createElement("path", { d: "M3.5 13a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3h-7Z" }),
        React.createElement("path", { d: "M19 14.5a1.5 1.5 0 0 0-3 0V17h-2.5a1.5 1.5 0 0 0 0 3H16v2.5a1.5 1.5 0 0 0 3 0V20h2.5a1.5 1.5 0 0 0 0-3H19v-2.5Z" })));
});
